import { WebsiteRead } from '@/api/dashboard'
import { cn } from '@dashboard/ui'

import { Table, TableCell, TableRow } from '@/ui'
import { useGenerateCompanyPath } from '@/libs'
import { TokenStudioGroupRow } from '../components'
import { useGroupedTheme } from '../hooks'

interface TokenStudioTableWidgetProps {
  website: WebsiteRead
}

export const TokenStudioTableWidget = ({ website }: TokenStudioTableWidgetProps) => {
  const { gameId } = useGenerateCompanyPath()
  const { data: groupedTheme, loading } = useGroupedTheme(gameId, website)

  const renderTableHeader = () => {
    return (
      <TableRow className="sticky top-0 z-10" variant="header">
        <TableCell width={80} />
        <TableCell width="150%">Name</TableCell>
        <TableCell width="200%">Value</TableCell>
        <TableCell width="75%">Resolved value</TableCell>
        <TableCell width="75%">Description</TableCell>
        <TableCell width={128} />
      </TableRow>
    )
  }

  return (
    <section className={cn('p-5 transition-all', loading && 'pointer-events-none animate-pulse opacity-25')}>
      <Table>
        {renderTableHeader()}
        <div>
          {Object.entries(groupedTheme || {})
            .filter(([key]) => key !== 'color')
            .map(([key, tokens]) => (
              <TokenStudioGroupRow key={`theme-group-${key}`} name={key} tokens={tokens} />
            ))}
        </div>
      </Table>
    </section>
  )
}
